














































































import { Component, Vue, Prop } from 'vue-property-decorator'
import FilterChart from './Components/FilterChart.vue'
import FilterTablePowerUser from './Components/FilterTablePowerUser.vue'
import TableMenu from './Components/TableMenu.vue'
import TableDealer from './Components/TableDealer.vue'
import TopMenu from './Components/TopMenu.vue'
import TableMaterial from './Components/TableMaterial.vue'
import { AuthModule } from '@/app/store/modules/auth'
import BarChart from './Components/BarChart/BarChart.vue'
import LineChart, { ILineChartData } from './Components/LineChart/LineChart.vue'
import { QuickGuideReportModule } from '@/app/store/modules/quickGuideReport'
import { UserReportModule } from '@/app/store/modules/userReport'
import Pagination from '@/app/ui/components/Pagination/index'

@Component({
  name: 'DashboardAdmin',
  components: {
    'top-menu': TopMenu,
    'bar-chart': BarChart,
    'line-chart': LineChart,
    'table-menu': TableMenu,
    'table-dealer': TableDealer,
    'filter-chart': FilterChart,
    'filter-table-power-user': FilterTablePowerUser,
    'table-material': TableMaterial,
    pagination: Pagination,
  },
})
export default class extends Vue {
  public created() {
    QuickGuideReportModule.paginationParam.filter.team = ''
    QuickGuideReportModule.paginationParam.filter.typeSales = ''
    // QuickGuideReportModule.paginationParam.filter.salescode = ''
    QuickGuideReportModule.paginationParam.filter.position = ''
    QuickGuideReportModule.paginationParam.filter.category = ''
    QuickGuideReportModule.paginationParam.filter.start = ''
    QuickGuideReportModule.paginationParam.filter.end = ''
    this.getGuideReportData()
    this.getUserData()
    this.getExportData()
  }

  public get needSalesCode() {
    const powerUser = AuthModule.salesCode.role
    if (powerUser !== 'Super Admin') {
      return true
    }
    return false
  }

  public get getUserData(): any {
    return UserReportModule.getUserData
  }

  public get dataCharts(): any {
    return UserReportModule.userData.chart
  }

  public get getGuideReportData(): any {
    return QuickGuideReportModule.getQuickGuideData
  }

  public get TopMenuData(): any {
    return QuickGuideReportModule.QuickGuideData.topMenu
  }
  public get ChartData(): any {
    return QuickGuideReportModule.QuickGuideData.chart
  }
  public get dataAccessRateCharts(): any {
    return QuickGuideReportModule.QuickGuideData.accessRateCharts
  }
  public get TopVisit(): any {
    return QuickGuideReportModule.QuickGuideData.topVisit
  }
  public get TopVisitByType(): any {
    return QuickGuideReportModule.QuickGuideData.topVisitType
  }
  public get MaterialDetailVisit(): any {
    return QuickGuideReportModule.QuickGuideData.materialVisitDetail
  }

  public get MaterialVisitPagination(): any {
    return QuickGuideReportModule.QuickGuideData.materialVisitPagination
  }

  public get getExportData(): any {
    return QuickGuideReportModule.getExportData
  }
  public get linkExport(): any {
    return QuickGuideReportModule.exportData.data
  }
  public get isLoadingExport() {
    return QuickGuideReportModule.isLoadingExport
  }

  public get isLoading(): boolean {
    return QuickGuideReportModule.isLoading
  }

  private onPageNumChanged(limit: any) {
    QuickGuideReportModule.paginationParam.paging.limit = limit
    this.getGuideReportData()
  }

  private funcFirstPage() {
    QuickGuideReportModule.paginationParam.paging.page = 1
    this.getGuideReportData()
  }

  private funcPrevPage() {
    QuickGuideReportModule.paginationParam.paging.page =
      QuickGuideReportModule.paginationParam.paging.page - 1
    this.getGuideReportData()
  }
  private funcNextPage() {
    QuickGuideReportModule.paginationParam.paging.page =
      QuickGuideReportModule.paginationParam.paging.page + 1
    this.getGuideReportData()
  }

  private funcLastPage() {
    QuickGuideReportModule.paginationParam.paging.page =
      (this.getGuideReportData.MaterialDetailVisitPagination &&
        this.getGuideReportData.MaterialDetailVisitPagination.pageCount) ||
      0
    this.getGuideReportData()
  }

  // Property Top Menu
  private funcFilter(data) {
    // QuickGuideReportModule.paginationParam.filter.salescode = ''
    QuickGuideReportModule.paginationParam.filter.team = data.team
    QuickGuideReportModule.paginationParam.filter.position = data.byPosition3
    QuickGuideReportModule.paginationParam.filter.typeSales = data.typeSales
    QuickGuideReportModule.paginationParam.filter.category = data.category.split(
      '/'
    )[1]
    QuickGuideReportModule.paginationParam.filter.start = data.filterDate[0]
    QuickGuideReportModule.paginationParam.filter.end = data.filterDate[1]
    QuickGuideReportModule.paginationParamsExport.filter.start =
      data.filterDate[0]
    QuickGuideReportModule.paginationParamsExport.filter.end =
      data.filterDate[1]
    this.getExportData()
    this.getGuideReportData()
  }

  private funcClearFilter() {
    this.clearFilter()
    QuickGuideReportModule.paginationParam.filter.team = ''
    // QuickGuideReportModule.paginationParam.filter.salescode = ''
    QuickGuideReportModule.paginationParam.filter.position = ''
    QuickGuideReportModule.paginationParam.filter.typeSales = ''
    QuickGuideReportModule.paginationParam.filter.category = ''
    QuickGuideReportModule.paginationParam.filter.start = ''
    QuickGuideReportModule.paginationParam.filter.end = ''
    QuickGuideReportModule.paginationParamsExport.filter.team = ''
    // QuickGuideReportModule.paginationParamsExport.filter.salescode = ''
    QuickGuideReportModule.paginationParamsExport.filter.position = ''
    QuickGuideReportModule.paginationParamsExport.filter.typeSales = ''
    QuickGuideReportModule.paginationParamsExport.filter.category = ''
    QuickGuideReportModule.paginationParamsExport.filter.start = ''
    QuickGuideReportModule.paginationParamsExport.filter.end = ''
    this.getExportData()
    this.getGuideReportData()
  }

  public get hasFilter(): boolean {
    if (
      QuickGuideReportModule.paginationParam.filter.team !== '' ||
      // QuickGuideReportModule.paginationParam.filter.salescode !== '' ||
      QuickGuideReportModule.paginationParam.filter.position !== '' ||
      QuickGuideReportModule.paginationParam.filter.typeSales !== '' ||
      QuickGuideReportModule.paginationParam.filter.category !== '' ||
      QuickGuideReportModule.paginationParam.filter.start !== '' ||
      QuickGuideReportModule.paginationParam.filter.end !== ''
    ) {
      return true
    } else {
      return false
    }
  }
  private onClearFilter: boolean = false
  private clearFilter() {
    if (this.onClearFilter === false) {
      this.onClearFilter = true
    } else {
      this.onClearFilter = false
    }
  }

  private nameCharts = 'User Access Graphic'
}
